import { template } from "@ember/template-compiler";
export default template(`
  <p
    class="cost-estimator-footer__estimate-label"
    data-test-cost-estimator-footer-label
  >
    {{yield}}
  </p>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvYmlsbGluZy1jb21tb24vcGFja2FnZS9zcmMvY29tcG9uZW50cy9iaWxsaW5nL2Nvc3QtZXN0aW1hdG9yL2xhYmVsLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyI8dGVtcGxhdGU-XG4gIDxwXG4gICAgY2xhc3M9XCJjb3N0LWVzdGltYXRvci1mb290ZXJfX2VzdGltYXRlLWxhYmVsXCJcbiAgICBkYXRhLXRlc3QtY29zdC1lc3RpbWF0b3ItZm9vdGVyLWxhYmVsXG4gID5cbiAgICB7e3lpZWxkfX1cbiAgPC9wPlxuPC90ZW1wbGF0ZT5cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsZUFBQSxTQUFVLENBQUE7Ozs7Ozs7QUFPVixDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUEsR0FBQyJ9